<script setup>
import { ref, onMounted, watch } from 'vue'
import { blogService } from '@/http'
import { useRoute, useRouter } from 'vue-router'

//import ImageUpload from '@/Components/ImageUpload.vue'

import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header'; 
import List from '@editorjs/list';
import ImageTool from '@editorjs/image';

import Headline from '@/Components/Headline.vue'

import ImageUpload from '@/Components/ImageUpload.vue'

const route = useRoute()
const router = useRouter()

let editor = null

class MyList extends List {
    constructor({ data, config, api, readOnly }) {
        super({ data, config, api, readOnly });
        this.settings.push(
          {
              name: 'Custom',
              title: 'Custom',
              icon: '<svg width="17" height="13" viewBox="0 0 17 13" xmlns="http://www.w3.org/2000/svg"><path d="M5.819 4.607h9.362a1.069 1.069 0 0 1 0 2.138H5.82a1.069 1.069 0 1 1 0-2.138zm0-4.607h9.362a1.069 1.069 0 0 1 0 2.138H5.82a1.069 1.069 0 1 1 0-2.138zm0 9.357h9.362a1.069 1.069 0 0 1 0 2.138H5.82a1.069 1.069 0 0 1 0-2.137zM1.468 4.155V1.33c-.554.404-.926.606-1.118.606a.338.338 0 0 1-.244-.104A.327.327 0 0 1 0 1.59c0-.107.035-.184.105-.234.07-.05.192-.114.369-.192.264-.118.475-.243.633-.373.158-.13.298-.276.42-.438a3.94 3.94 0 0 1 .238-.298C1.802.019 1.872 0 1.975 0c.115 0 .208.042.277.127.07.085.105.202.105.351v3.556c0 .416-.15.624-.448.624a.421.421 0 0 1-.32-.127c-.08-.085-.121-.21-.121-.376zm-.283 6.664h1.572c.156 0 .275.03.358.091a.294.294 0 0 1 .123.25.323.323 0 0 1-.098.238c-.065.065-.164.097-.296.097H.629a.494.494 0 0 1-.353-.119.372.372 0 0 1-.126-.28c0-.068.027-.16.081-.273a.977.977 0 0 1 .178-.268c.267-.264.507-.49.722-.678.215-.188.368-.312.46-.371.165-.11.302-.222.412-.334.109-.112.192-.226.25-.344a.786.786 0 0 0 .085-.345.6.6 0 0 0-.341-.553.75.75 0 0 0-.345-.08c-.263 0-.47.11-.62.329-.02.029-.054.107-.101.235a.966.966 0 0 1-.16.295c-.059.069-.145.103-.26.103a.348.348 0 0 1-.25-.094.34.34 0 0 1-.099-.258c0-.132.031-.27.093-.413.063-.143.155-.273.279-.39.123-.116.28-.21.47-.282.189-.072.411-.107.666-.107.307 0 .569.045.786.137a1.182 1.182 0 0 1 .618.623 1.18 1.18 0 0 1-.096 1.083 2.03 2.03 0 0 1-.378.457c-.128.11-.344.282-.646.517-.302.235-.509.417-.621.547a1.637 1.637 0 0 0-.148.187z"/></svg>',
              default: false,
          },
        );
        this._data = {
            style: this.settings.find((tune) => tune.default === true).name,
            items: [],
        };
        this.data = data;
    }
}

const loadEditor = (body = {}) => {
  editor = new EditorJS({
    holder: 'editorjs',
    placeholder: 'Давайте напишем потрясающую историю!',
    data: body,
    tools: { 
      header: Header, 
      list: MyList,
    //   embed: {
    //     class: Embed,
    //     inlineToolbar: true
    //   },
      image: {
        class: ImageTool,
        inlineToolbar: true,
        // config: {
        //   additionalRequestHeaders: {
        //       "x-xsrf-token": cookie.get('XSRF-TOKEN')
        //   },
        //   endpoints: {
        //     byFile: '/adpi/upload',
        //     byUrl: '/adpi/upload',
        //   }
        // }
        config: {
          uploader: {
              uploadByFile(file) {
                return helpService.upload(file)
              }
            }
          }
        }
    }, 
  })
}


const convertData = (timestamp) => {
  return new Date(timestamp)
  .toISOString() // Convert to ISO string
  .slice(0, 16);
}

const item = ref({
    id: ''
})


const fetchData = () => {
    blogService.get({id: route.params.id}).then(res => {
        item.value = res.data
        loadEditor(JSON.parse(res.data.text))
    })
}

const onSave = async () => {
    
    let data = {...item.value};

    console.log(item.value, data)

    let text = await editor.save();
    data.text = JSON.stringify(text)

    blogService.save(data).then(res => {
        if(!route.params.id) {
            router.push({
                name: 'blog',
                params: {
                    id: res.data.id
                }
            })
            item.value = res.data;
        }
    })
}

const onDelete = () => {
    blogService.delete({id: route.params.id}).then(res => {
        router.push({
            name: 'index'
        })
    })
}

// onMounted(() => {
//   item.value = {}
//   if(!route.params.id) {
//       loadEditor();
//       return;
//   }
//   fetchData();
// })


watch(
  () => item,
  async () => {
    console.log(3333, item.value.created_at)
  },
  {
    flush: 'post',
    immediate: true
  }
)

watch(
  () => route.params,
  async () => {
    item.value = {}
    loadEditor();
    return;
    if(!route.params.id) {
        loadEditor();
        return;
    }
    //fetchData();
  },
  {
    flush: 'post',
    immediate: true
  }
)

</script>
<template>
<div class="blog">
    <div class="edit">
        <div class="edit__form">
            <form class="form" @submit.prevent="onSave">
                <v-input v-model="item.title" label="Тайтл" :required="true" />

                <ImageUpload v-model="item.image" class="image-upload--wide" />

                <div class="editor">
                    <div id="editorjs"></div>
                </div>

                <div class="edit__menu">
                    <button class="btn btn--full" type="submit">Сохранить</button>
                </div>
            </form>
        </div>
    </div>
</div>
</template>



<style lang="scss">

.edit {
    &__menu {
        position: fixed;
        bottom: 20px;
        left: 0;
        right: 0;
        display: flex;
        gap: 10px;
        margin-top: 25px;
        z-index: 100;
        padding: 0 var(--gutter);

        @include mq('md') {
          max-width: 620px;
          left: 50%;
          transform: translateX(-50%);
          padding: 0;
        }
    }
}

.editor {
  border: 1px solid var(--border);
  border-radius: var(--border-radius);
  padding: 20px;

  .ce-block__content, .ce-toolbar__content {
    max-width: 100%;
  }


  .input-embed {
    width: 100%;
    border: 1px solid var(--border);
    padding: 10px;

    input {
      width: 100%;
      border: 1px solid var(--border);
      padding: 10px;
    }
  }
}
</style>